class LocationBlock {
    constructor(el) {
        this.scope = el;
        this.mapWrapper = el.querySelector("[data-map-wrapper]");
        this.mapToggle = el.querySelector("[data-map-toggle]");
        this.coords = this.mapWrapper.dataset.coords.split(",");
        this.id = this.mapWrapper.dataset.locationId;
        this.map = null;
        this.getDirectionLinks = el.querySelectorAll("[data-get-directions]");
        if(this.coords !== null && this.id !== null){
            this.bindEvents();
        }
    }
    bindEvents() {
        let options = {
            locations: {
                locations: [{
                    "latitude": parseFloat(this.coords[0]),
                    "longitude": parseFloat(this.coords[1]),
                    nodeId: this.id
                }]
            },
            openWindow: true,
            zoomControl: true,
            fullscreenControl: true
        };
        this.mapToggle.addEventListener("click", () => {
            this.map = new GoogleMap(this.mapWrapper, options);
        });
        this.getDirectionLinks.forEach(link =>{
            link.addEventListener("click", ()=> LocationBlock.getDirections(this.coords));
        })
    }
   
    static getDirections(coords){
        navigator.permissions.query({ name: "geolocation" }).then((result) => {
            let mapURL = "https://www.google.com/maps/dir/";
            function failure(){
                redirect(`${mapURL}/${coords}/`)
            }
            if (result.state === "granted" || result.state === "prompt") {
                navigator.geolocation.getCurrentPosition((position) => {
                    redirect(`${mapURL}${[position.coords.latitude, position.coords.longitude]}/${coords}/`);
                }, failure);
            }  else  {
                failure();
            }
        });
        const redirect = (url) =>{
            if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                window.location.replace(url);
            }else{
                window.open(url);
            }
        }
    }
}
ControlBinders.register(`[data-location-block]`, el => new LocationBlock(el));
